import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["SSIBlock"] */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/components/ssi-block.tsx");
